
/*
 * ARS Mobilya - WhatsApp Sepet Siparişi
 * WhatsApp: +90 535 520 68 53
 *
 * Minicom standart sepet ve açılır sepet butonları.
 * Mevcut butonların görünümünü değiştirmez.
 */

(function () {
  "use strict";

  const WHATSAPP_NUMBER = "905355206853";

  const CHECKOUT_SELECTOR = [
    'button[name="checkout"]',
    'input[type="submit"][name="checkout"]',
    '.cart__checkout',
    'a[href="/checkout"]',
    'a[href^="/checkout?"]'
  ].join(", ");

  let redirecting = false;

  function formatPrice(cents, currency) {
    const amount = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat("tr-TR", {
        style: "currency",
        currency: currency || "TRY"
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2) + " TL";
    }
  }

  function formatPropertyValue(value) {
    if (value === null || value === undefined) {
      return "";
    }

    if (typeof value === "string") {
      return value.trim();
    }

    if (Array.isArray(value)) {
      return value.map(formatPropertyValue).join(", ");
    }

    if (typeof value === "object") {
      return JSON.stringify(value);
    }

    return String(value);
  }

  function buildMessage(cart) {
    const currency = cart.currency || "TRY";

    const lines = [
      "Merhaba, ARS Mobilya'dan sipariş vermek istiyorum.",
      "",
      "SEPETİM",
      "------------------------"
    ];

    cart.items.forEach(function (item, index) {
      const quantity = Number(item.quantity || 1);

      lines.push(
        (index + 1) + ". " +
        (item.product_title || item.title)
      );

      if (
        item.variant_title &&
        item.variant_title !== "Default Title"
      ) {
        lines.push("Varyant: " + item.variant_title);
      }

      const properties = item.properties || {};

      Object.keys(properties).forEach(function (key) {
        // Shopify'ın dahili/gizli özelliklerini gösterme.
        if (key.charAt(0) === "_") {
          return;
        }

        const value = formatPropertyValue(properties[key]);

        if (value) {
          lines.push(key + ": " + value);
        }
      });

      lines.push("Adet: " + quantity);

      lines.push(
        "Birim fiyat: " +
        formatPrice(item.final_price ?? item.price, currency)
      );

      lines.push(
        "Ara toplam: " +
        formatPrice(
          item.final_line_price ?? item.line_price,
          currency
        )
      );

      if (item.url) {
        lines.push(
          "Ürün: " +
          window.location.origin +
          item.url
        );
      }

      lines.push("");
    });

    lines.push("------------------------");

    lines.push(
      "SEPET TOPLAMI: " +
      formatPrice(cart.total_price, currency)
    );

    lines.push("");
    lines.push(
      "Sipariş ve teslimat detayları hakkında bilgi almak istiyorum."
    );

    return lines.join("\n");
  }

  async function openWhatsApp() {
    if (redirecting) {
      return;
    }

    redirecting = true;

    // Mobil tarayıcılarda yeni sekme engelini azaltmak
    // için yönlendirmeyi mevcut sekmede yapıyoruz.
    try {
      const root =
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root
          : "/";

      const response = await fetch(root + "cart.js", {
        method: "GET",
        credentials: "same-origin",
        cache: "no-store",
        headers: {
          Accept: "application/json"
        }
      });

      if (!response.ok) {
        throw new Error("Sepet okunamadı.");
      }

      const cart = await response.json();

      if (!cart.items || cart.items.length === 0) {
        alert("Sepetiniz boş. Lütfen önce ürün ekleyin.");
        redirecting = false;
        return;
      }

      const message = buildMessage(cart);

      const whatsappUrl =
        "https://wa.me/" +
        WHATSAPP_NUMBER +
        "?text=" +
        encodeURIComponent(message);

      window.location.assign(whatsappUrl);
    } catch (error) {
      console.error(
        "ARS Mobilya WhatsApp sepet hatası:",
        error
      );

      alert(
        "Sepet bilgileri alınamadı. " +
        "Lütfen sayfayı yenileyip tekrar deneyin."
      );

      redirecting = false;
    }
  }

  function isCheckoutButton(element) {
    if (!element || !element.matches) {
      return false;
    }

    return element.matches(CHECKOUT_SELECTOR);
  }

  function getCheckoutButton(target) {
    if (!(target instanceof Element)) {
      return null;
    }

    return target.closest(CHECKOUT_SELECTOR);
  }

  // Dinamik oluşturulan açılır sepet butonlarını da yakalar.
  document.addEventListener(
    "click",
    function (event) {
      const button = getCheckoutButton(event.target);

      if (!button) {
        return;
      }

      if (button.disabled) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      openWhatsApp();
    },
    true
  );

  // Enter tuşu veya form üzerinden standart checkout
  // gönderimini de engeller.
  document.addEventListener(
    "submit",
    function (event) {
      const form = event.target;

      if (!(form instanceof HTMLFormElement)) {
        return;
      }

      const submitter = event.submitter;

      const hasCheckoutSubmitter =
        submitter && isCheckoutButton(submitter);

      const hasCheckoutForm =
        form.matches('form[action*="/checkout"]');

      if (!hasCheckoutSubmitter && !hasCheckoutForm) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      openWhatsApp();
    },
    true
  );
})();
